const DEVELOPMENT_URL = `http://192.168.1.28:2810/v1`;
const STAGING_URL = `https://retail.pos.api.ansoftt.com:5287/v1`;
const PRODUCTION_URL = `https://retail.pos.api.ansoftt.com:2288/v1`;

export const BASE_URL = PRODUCTION_URL;
export const IS_TESTING = false;

